export default "__VITE_ASSET__DdfVLYev__"